import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const mediaSlice = createSlice({
  name: 'mediaSliceName',
  initialState,
  reducers: {
    addMedia: (state) => {
      state.loading = true;
    },
    getMedia: (state) => {
      state.loading = true;
    },
    getOneMedia: (state) => {
      state.loading = true;
    },

    successMedia: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    removeMedia: (state) => {
      state.loading = true;
    },
    updateMedia: (state) => {
      state.loading = true;
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { addMedia, removeMedia, updateMedia, getMedia, successMedia, getOneMedia } = mediaSlice.actions

export default mediaSlice.reducer